module.exports = __webpack_public_path__ + "static/media/joyce_ang.733f7d6c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joyce_ang.webp
// module id = 92
// module chunks = 0